import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { promise } from 'protractor';
import { PageBase, QueuedMessagePriority, QueuedMessageSettingInfo, QueuedMessageCategory, QueuedMessageMethod } from 't4core';
import { CampaignInfo, DiscountModel, DiscountReasonInfo } from '../../../../../projects/t4core/src/public-api';

import * as moment from 'moment';
import { FindCampaignDialog } from '../../dialogs/findCampaignDialog/findCampaignDialog';

@Component({
  styleUrls: ['./campaignlist.component.css'],
  selector: 'list',
  templateUrl: './campaignlist.component.html',
})

export class CampaignListComponent extends PageBase implements OnInit {

  public dateNow: any;

  public constructor(el: ElementRef, private router: Router) {
    super(el, "Campaign");
    this.loading;
  }

  public async ngOnInit() {

    this.ContextId = ""; // T4C.Current.ContextId C#
    this.isLoading = true;
    await this.loadActiveCampaigns();
    await this.loadTemplates();
    await this.loadNotificationSettings();
    await this.loadArcivedCampaigns();
    // await this.loadInheritedCampains();
    await this.loadSingleDiscounts();
    await this.loadReasons();
    this.isLoading = false;
  }

  // Data model
  public ActiveCampains: any = [];
  public Templates: any = [];
  public ArcivedCampains: any = [];
  public InheritedCampains: any[];
  public SingleDiscounts: any[];

  public Reasons: any = [];
  public ContextId: string;
  public isLoading: boolean = false;

  public loading: any = {
    ActiveCampains: false,
    Templates: false,
    ArcivedCampains: false,
    InheritedCampains: false,
    SingleDiscount: false,
    Notifications: false,
  };

  public settings: QueuedMessageSettingInfo[] = [];

  public priorities = [
    { Id: QueuedMessagePriority.Low, Name: this.translate('Turbo.Notifications.QueuedMessagePriority.Low', 'Low') },
    { Id: QueuedMessagePriority.Normal, Name: this.translate('Turbo.Notifications.QueuedMessagePriority.Normal', 'Normal') },
    { Id: QueuedMessagePriority.High, Name: this.translate('Turbo.Notifications.QueuedMessagePriority.High', 'High') }
  ];

  public categories = [
    { Id: QueuedMessageCategory.CustomerConfirmation, Name: this.translate('Turbo.Notifications.Category.CustomerConfirmation', 'Customer confirmation') },
    { Id: QueuedMessageCategory.InternalNotification, Name: this.translate('Turbo.Notifications.Category.InternalNotification', 'Internal notification') },
    { Id: QueuedMessageCategory.Marketing, Name: this.translate('Turbo.Notifications.Category.Marketing', 'Marketing') },
    { Id: QueuedMessageCategory.Reminder, Name: this.translate('Turbo.Notifications.Category.Reminder', 'Reminder') },
    { Id: QueuedMessageCategory.CustomerService, Name: this.translate('Turbo.Notifications.Category.CustomerService', 'Customer service') }
  ];

  public methods = [
    { Id: QueuedMessageMethod.Notification, Name: this.translate('Turbo.Notifications.QueuedMessageMethod.Notification', 'App notification') },
    { Id: QueuedMessageMethod.Sms, Name: this.translate('Turbo.Notifications.QueuedMessageMethod.Sms', 'Sms') },
    { Id: QueuedMessageMethod.Email, Name: this.translate('Turbo.Notifications.QueuedMessageMethod.Email', 'Email') }
  ];

  private async loadActiveCampaigns(): Promise<Boolean> {
    this.loading.ActiveCampains = true;
    this.ActiveCampains = await this.Api.get<CampaignInfo[]>("/Campaign/GetActiveCampaigns");
      this.loading.ActiveCampains = false;
    this.dateNow = moment.now();

    return true;
  }

  private async loadTemplates(): Promise<Boolean> {
    this.loading.Templates = true;
    this.Templates = await this.Api.get<CampaignInfo[]>("/Campaign/GetTemplates");
    this.loading.Templates = false;
    this.dateNow = moment.now();

    return true;
  }

/*
  private async loadInheritedCampains(): Promise<Boolean> {
    this.loading.InheritedCampains = true;
    this.InheritedCampains = await this.Api.get<CampaignInfo[]>("/Campaign/GetInheritedCampaigns");
    this.loading.InheritedCampains = false;

    return true;
  } 
  */

  private async loadReasons(): Promise<Boolean> {
    this.loading.Reasons = true;
    this.Reasons = await this.Api.get<DiscountReasonInfo>("/Campaign/GetDiscountReasons");
    this.loading.Reasons = false;

    return true;
  }

  public async generateCampaign(): Promise<Boolean> {

    var ret = await this.UI.openDialog<CampaignInfo>("T4.Campaigns.CreateCampaignDialog", { data: null });
    if (ret) {
      this.gotoCampaign(ret);
    }
    return true;
  }


  private async loadArcivedCampaigns(): Promise<Boolean> {
    this.loading.ActiveCampains = true;
    this.ArcivedCampains = await this.Api.get<CampaignInfo[]>("/Campaign/GetArchivedCampaigns");
    this.loading.ArcivedCampains = false;

    return true;
  }

  public async loadSingleDiscounts(): Promise<Boolean> {
    this.loading.SingleDiscount = true;
    this.SingleDiscounts = await this.Api.get<CampaignInfo[]>("/Campaign/GetSingleDiscount");
    this.loading.singleDiscounts = false;

    return true;
  }

  public gotoCampaign(campaign: CampaignInfo) {
    this.router.navigateByUrl("/Campaigns/Campaign/" + campaign.DiscountCode);
  }

  public findCampaign() {
    this.Dialog.open(FindCampaignDialog, {
    });
  }

  public async loadNotificationSettings() {
    this.loading.Notifications = true;
    try {
      this.settings = await this.Api.get<QueuedMessageSettingInfo[]>("/Notification/GetNotificationSettings");
    } finally {
      this.loading.Notifications = false;
    }
  }

  public createNotifications() {
    this.router.navigate(['/Campaigns/NotificationSettings/create']);
  }

  public open(setting: QueuedMessageSettingInfo) {
    this.router.navigate(['/Campaigns/NotificationSettings', setting.Id]);
  }

  public getCategoryName(category: number): string {
    return this.categories.find(x => x.Id === category)?.Name ?? category?.toString();
  }

  getPriorityName(priority: number): string {
    return this.priorities.find(x => x.Id === priority)?.Name ?? priority?.toString();
  }

  getMethodName(id?: number): string {
    if (!id) {
      return '';
    }

    return this.methods.find(x => x.Id === id)?.Name ?? '';
  }
}
